import PeerCompaniesDividendInfoComponent from './PeerCompaniesDividendInfo.vue';
import MkApolloProvider from '../../../utils/MkApolloProvider';
import FavoriteSignUpModal from '../../Modal/FavoriteSignUpModal.vue';

/*
 * 個別銘柄 他社比較ルートコンポーネント
 */
const PeerCompaniesDividendInfo = {
  el: '#v-peer-companies-dividend-info',
  apolloProvider: MkApolloProvider,
  data: { isHide: false },
  components: {
    PeerCompaniesDividendInfo: PeerCompaniesDividendInfoComponent,
    FavoriteSignUpModal,
  },
  methods: {
    switchHideFlg(val) {
      this.isHide = !val;
    },
  },
};

export default PeerCompaniesDividendInfo;
